import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
const VARIANT_CLASS = {
    default: undefined,
    coral: 'sec-card--coral',
    invert: 'sec-card--invert',
};
/** Container-Flaeche fuer gruppierte Inhalte (Panels, Listen, Dialoge). */
export const Card = forwardRef(function Card({ variant = 'default', className, ...rest }, ref) {
    return _jsx("div", { ref: ref, className: cn('sec-card', VARIANT_CLASS[variant], className), ...rest });
});
